import {
  Circle,
  Document,
  Image,
  Line,
  Page,
  Path,
  StyleSheet,
  Svg,
  Text,
  View,
} from "@react-pdf/renderer";
import hiLogo from "../../assets/hireintelligence.png";

const COLORS = {
  teal: "#00A99E",
  charcoal: "#0A0A0A",
  amber: "#C97A2B",
  lightBg: "#F7F9F9",
  white: "#FFFFFF",
  grey: "#555555",
  border: "#E4E4E4",
  body: "#434343",
};

const styles = StyleSheet.create({
  page: {
    paddingTop: 82,
    paddingBottom: 62,
    paddingHorizontal: 38,
    backgroundColor: COLORS.lightBg,
    color: COLORS.charcoal,
    fontFamily: "Helvetica",
    fontSize: 10,
  },
  pageHeader: {
    position: "absolute",
    top: 25,
    left: 38,
    right: 38,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: COLORS.border,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerLogo: {
    width: 64,
    height: 24,
    objectFit: "contain",
  },
  pageFooter: {
    position: "absolute",
    bottom: 23,
    left: 38,
    right: 38,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: COLORS.border,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  footerText: {
    color: COLORS.grey,
    fontSize: 8,
  },
  hero: {
    backgroundColor: COLORS.charcoal,
    borderBottomWidth: 6,
    borderBottomColor: COLORS.teal,
    borderRadius: 4,
    paddingHorizontal: 28,
    paddingVertical: 26,
    marginBottom: 28,
  },
  heroTitle: {
    color: COLORS.white,
    fontSize: 22,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 8,
  },
  heroDate: {
    color: COLORS.teal,
    fontWeight: "bold",
    fontSize: 13,
    textAlign: "center",
  },
  heroStats: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginTop: 20,
  },
  heroStat: {
    width: "31.5%",
    minHeight: 64,
    padding: 12,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: COLORS.teal,
    borderRadius: 8,
    backgroundColor: "#12312F",
  },
  heroStatValue: {
    color: COLORS.teal,
    fontWeight: "bold",
    fontSize: 19,
    marginBottom: 4,
  },
  heroStatLabel: {
    color: "#D7E3E2",
    fontSize: 9,
  },
  section: {
    marginBottom: 0,
  },
  sectionTitle: {
    color: COLORS.teal,
    fontWeight: "bold",
    fontSize: 17,
    marginBottom: 8,
  },
  iconTextRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  sectionRule: {
    width: 58,
    height: 3,
    backgroundColor: COLORS.teal,
    borderRadius: 2,
    marginBottom: 16,
  },
  card: {
    backgroundColor: COLORS.white,
    borderRadius: 7,
    paddingHorizontal: 18,
    paddingVertical: 16,
    marginBottom: 12,
  },
  leftTeal: {
    borderLeftWidth: 4,
    borderLeftColor: COLORS.teal,
  },
  leftAmber: {
    borderLeftWidth: 4,
    borderLeftColor: COLORS.amber,
  },
  topTeal: {
    borderTopWidth: 3,
    borderTopColor: COLORS.teal,
  },
  topAmber: {
    borderTopWidth: 3,
    borderTopColor: COLORS.amber,
  },
  cardTitle: {
    color: COLORS.charcoal,
    fontWeight: "bold",
    fontSize: 12,
    marginBottom: 9,
  },
  body: {
    color: COLORS.body,
    fontSize: 10,
    lineHeight: 1.55,
  },
  listItem: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 7,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    marginTop: 4,
    marginRight: 9,
  },
  darkCallout: {
    backgroundColor: COLORS.charcoal,
    borderRadius: 7,
    paddingHorizontal: 18,
    paddingVertical: 15,
    marginTop: 4,
  },
  tealLabel: {
    color: COLORS.teal,
    fontSize: 9,
    fontWeight: "bold",
    marginBottom: 7,
  },
  findingHeader: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 4,
  },
  findingNumber: {
    width: 25,
    height: 25,
    borderRadius: 13,
    backgroundColor: COLORS.teal,
    color: COLORS.white,
    textAlign: "center",
    paddingTop: 6,
    fontSize: 10,
    fontWeight: "bold",
    marginRight: 10,
  },
  findingTitle: {
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
    color: COLORS.charcoal,
    fontSize: 14,
    fontWeight: "bold",
    paddingTop: 4,
  },
  subheading: {
    color: COLORS.grey,
    fontSize: 10,
    fontStyle: "italic",
    marginBottom: 10,
  },
  divider: {
    height: 1,
    backgroundColor: COLORS.border,
    marginVertical: 10,
  },
  statGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  findingStat: {
    width: "23.5%",
    padding: 9,
    marginBottom: 8,
    borderRadius: 6,
  },
  statLabel: {
    color: "#666666",
    fontSize: 8,
    marginBottom: 4,
  },
  statValue: {
    color: COLORS.charcoal,
    fontSize: 11,
    fontWeight: "bold",
  },
  contentBlock: {
    marginTop: 11,
  },
  table: {
    borderWidth: 1,
    borderColor: COLORS.border,
    marginTop: 4,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: COLORS.border,
  },
  tableHeader: {
    backgroundColor: "#E9F5F4",
  },
  tableCell: {
    flexGrow: 1,
    flexBasis: 0,
    padding: 7,
    borderRightWidth: 1,
    borderRightColor: COLORS.border,
    fontSize: 8,
  },
  tableHeaderText: {
    color: COLORS.charcoal,
    fontWeight: "bold",
  },
  splitRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  snapshotGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  splitCard: {
    width: "48.5%",
  },
  keyValueRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  keyValueLabel: {
    width: "56%",
    color: COLORS.body,
  },
  keyValueValue: {
    width: "42%",
    textAlign: "right",
    fontWeight: "bold",
  },
  rank: {
    width: 20,
    color: COLORS.teal,
    fontWeight: "bold",
  },
  muted: {
    color: COLORS.grey,
    fontSize: 9,
    marginTop: 3,
  },
  expectedOutcome: {
    backgroundColor: COLORS.teal,
    padding: 12,
    borderRadius: 6,
    marginTop: 16,
    justifyContent: "center",
  },
  expectedOutcomeText: {
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
    color: COLORS.white,
    textAlign: "center",
    fontSize: 12,
    fontWeight: "bold",
  },
});

const valueText = (value, fallback = "—") =>
  value === null || value === undefined ? fallback : String(value);

const hasSnapshotContent = (snapshot) =>
  Boolean(
    snapshot?.portfolio_metrics?.length ||
    snapshot?.paid_vs_free?.length ||
    snapshot?.top_occupations?.length ||
    snapshot?.areas_to_explore?.length ||
    snapshot?.highlights?.strongest_site ||
    snapshot?.highlights?.weakest_site ||
    (snapshot?.table?.headers?.length &&
      Array.isArray(snapshot.table.rows))
  );

const hasWhyNowContent = (data) =>
  Boolean(
    data?.opening_statement ||
    data?.recommendations_recap?.length ||
    data?.expected_outcome
  );

const PdfIcon = ({ icon, size = 12, style }) => {
  if (typeof icon === "string" && icon.startsWith("number-")) {
    return (
      <View
        style={[
          {
            width: size,
            height: size,
            borderRadius: size / 2,
            backgroundColor: COLORS.teal,
            alignItems: "center",
            justifyContent: "center",
          },
          style,
        ]}
      >
        <Text
          style={{
            color: COLORS.white,
            fontSize: size * 0.55,
            fontWeight: "bold",
          }}
        >
          {icon.slice(-1)}
        </Text>
      </View>
    );
  }

  let shapes;

  switch (icon) {
    case "chart":
      shapes = (
        <Path
          d="M3 21h18M6 18v-5h3v5M11 18V5h3v13M16 18v-8h3v8"
          fill="none"
          stroke={COLORS.teal}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      );
      break;

    case "check":
      shapes = (
        <>
          <Circle cx="12" cy="12" r="10" fill="#52C41A" />
          <Path
            d="m7 12 3.2 3.2L17.5 8"
            fill="none"
            stroke={COLORS.white}
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
      break;

    case "search":
      shapes = (
        <>
          <Circle
            cx="10.5"
            cy="10.5"
            r="6.5"
            fill="#E6F4FF"
            stroke="#2878A5"
            strokeWidth="2"
          />
          <Line
            x1="15.5"
            y1="15.5"
            x2="21"
            y2="21"
            stroke="#2878A5"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </>
      );
      break;

    case "target":
      shapes = (
        <>
          <Circle
            cx="12"
            cy="12"
            r="9"
            fill="#FFF1F0"
            stroke="#E5534B"
            strokeWidth="2"
          />
          <Circle
            cx="12"
            cy="12"
            r="5"
            fill="none"
            stroke="#E5534B"
            strokeWidth="2"
          />
          <Circle cx="12" cy="12" r="1.7" fill="#E5534B" />
          <Path
            d="m13.5 10.5 6-6m-3 .2 2.8.1.1 2.8"
            fill="none"
            stroke="#555"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
      break;

    case "trophy":
      shapes = (
        <>
          <Path
            d="M7 4h10v4c0 4-2 6-5 6S7 12 7 8V4Z"
            fill="#F6C445"
            stroke="#A86E16"
            strokeWidth="1.5"
          />
          <Path
            d="M7 6H4v2c0 2 1.2 3.5 3.5 4M17 6h3v2c0 2-1.2 3.5-3.5 4M12 14v4m-4 2h8m-6-2h4"
            fill="none"
            stroke="#A86E16"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
      break;

    case "scales":
      shapes = (
        <>
          <Path
            d="M12 4v15m-7 1h14M5 7h14M12 4l-2 3m2-3 2 3M5 7l-3 7h6L5 7Zm14 0-3 7h6l-3-7Z"
            fill="none"
            stroke="#52718A"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <Path
            d="M2 14c.5 2 1.5 3 3 3s2.5-1 3-3m8 0c.5 2 1.5 3 3 3s2.5-1 3-3"
            fill="#DDF4FF"
            stroke="#52718A"
            strokeWidth="1.4"
          />
        </>
      );
      break;

    case "muscle":
      shapes = (
        <Path
          d="M5 17c1.2-1.4 2.3-2 3.7-2 .9-2.2 1.3-4 2.5-5.4.8-.9 2-.8 2.5.2l.8 1.7 2.1-.7c1-.3 2 .3 2 1.4 1.4.1 2.3 1.4 1.8 2.7-.5 1.7-2.2 3.2-4.5 4.1-3.7 1.5-7.5 1.1-10.9-.1L5 17Z"
          fill="#F2B27C"
          stroke="#A85C35"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      );
      break;

    case "sparkles":
      shapes = (
        <>
          <Path
            d="m9 2 1.7 5.3L16 9l-5.3 1.7L9 16l-1.7-5.3L2 9l5.3-1.7L9 2Zm10 11 1.1 3.1L23 17l-2.9.9L19 21l-1.1-3.1L15 17l2.9-.9L19 13Z"
            fill="#F6C445"
            stroke="#D28B1D"
            strokeWidth="1"
            strokeLinejoin="round"
          />
          <Path
            d="m18 2 .7 2.3L21 5l-2.3.7L18 8l-.7-2.3L15 5l2.3-.7L18 2Z"
            fill="#76CFC6"
          />
        </>
      );
      break;

    default:
      shapes = null;
  }

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" style={style}>
      {shapes}
    </Svg>
  );
};

const IconText = ({
  icon,
  children,
  textStyle,
  containerStyle,
  size = 12,
  bottomSpacing = 0,
}) => (
  <View
    style={[
      styles.iconTextRow,
      containerStyle,
      { marginBottom: bottomSpacing },
    ]}
  >
    <PdfIcon icon={icon} size={size} style={{ marginRight: 5 }} />
    <Text style={[textStyle, { marginBottom: 0 }]}>{children}</Text>
  </View>
);

const SectionHeader = ({ icon, title }) => (
  <View>
    <IconText
      icon={icon}
      size={16}
      textStyle={styles.sectionTitle}
      bottomSpacing={8}
    >
      {title}
    </IconText>
    <View style={styles.sectionRule} />
  </View>
);

const BulletList = ({ items = [], colour = COLORS.teal }) => (
  <View>
    {(items || []).map((item, index) => (
      <View key={index} style={styles.listItem}>
        <View style={[styles.dot, { backgroundColor: colour }]} />
        <Text
          style={[
            styles.body,
            {
              flexBasis: 0,
              flexGrow: 1,
              flexShrink: 1,
              minWidth: 0,
            },
          ]}
        >
          {valueText(item, "")}
        </Text>
      </View>
    ))}
  </View>
);
const Hero = ({ report }) => {
  const meta = report?.meta || {};
  const stats = report?.hero_stats || [];

  return (
    <View style={styles.hero}>
      <Text style={styles.heroTitle}>
        Executive Summary{meta.buyer_name ? ` — ${meta.buyer_name}` : ""}
      </Text>

      <Text style={styles.heroDate}>
        {meta.date_range_display || "—"}
      </Text>

      {meta.sub_buyer_count !== null &&
        meta.sub_buyer_count !== undefined && (
          <Text
            style={{
              color: "#D7E3E2",
              fontSize: 9,
              textAlign: "center",
              marginTop: 5,
            }}
          >
          {`${meta.sub_buyer_count} Cost Centers`}
          </Text>
        )}

      {!!stats.length && (
        <View style={styles.heroStats}>
          {stats.map((item, index) => (
            <View key={index} style={styles.heroStat}>
              <Text style={styles.heroStatValue}>
                {valueText(item?.value)}
              </Text>
              <Text style={styles.heroStatLabel}>
                {valueText(item?.label, "")}
              </Text>
            </View>
          ))}
        </View>
      )}
    </View>
  );
};

const OneMinuteRead = ({ data }) => {
  if (!data) return null;

  return (
    <View style={styles.section}>
      <SectionHeader icon="number-1" title="One-Minute Read" />

      {data.headline && (
        <View wrap={false} style={[styles.card, styles.leftTeal]}>
          <IconText
            icon="chart"
            size={15}
            textStyle={styles.cardTitle}
            bottomSpacing={9}
          >
            The Headline
          </IconText>
          <Text style={styles.body}>{data.headline}</Text>
        </View>
      )}

      <View>
        <View wrap={false} style={[styles.card, styles.leftTeal]}>
          <IconText
            icon="check"
            textStyle={styles.cardTitle}
            bottomSpacing={9}
          >
            What's Working
          </IconText>
          <BulletList items={data.whats_working} />
        </View>

        <View wrap={false} style={[styles.card, styles.leftAmber]}>
          <IconText
            icon="search"
            textStyle={styles.cardTitle}
            bottomSpacing={9}
          >
            Room to Improve
          </IconText>
          <BulletList
            items={data.room_to_improve}
            colour={COLORS.amber}
          />
        </View>
      </View>

      {data.opportunity_statement && (
        <View wrap={false} style={styles.darkCallout}>
          <IconText
            icon="target"
            size={10}
            textStyle={styles.tealLabel}
            bottomSpacing={7}
          >
            OPPORTUNITY
          </IconText>
          <Text style={[styles.body, { color: COLORS.white }]}>
            {data.opportunity_statement}
          </Text>
        </View>
      )}
    </View>
  );
};

const backgroundForColour = (colour) => {
  const backgrounds = {
    green: "#F6FFED",
    lime: "#FCFFE6",
    cyan: "#E6FFFB",
    blue: "#E6F4FF",
    geekblue: "#F0F5FF",
    purple: "#F9F0FF",
    magenta: "#FFF0F6",
    pink: "#FFF0F6",
    red: "#FFF2F0",
    volcano: "#FFF2E8",
    orange: "#FFF7E6",
    gold: "#FFFBE6",
    yellow: "#FEFFE6",
    amber: "#FFFBE6",
    grey: "#FAFAFA",
    gray: "#FAFAFA",
  };

  return backgrounds[(colour || "").toLowerCase()] || COLORS.lightBg;
};

const FindingStats = ({ stats = [] }) => {
  if (!stats.length) return null;

  return (
    <View style={styles.statGrid}>
      {stats.map((stat, index) => (
        <View
          key={index}
          style={[
            styles.findingStat,
            { backgroundColor: backgroundForColour(stat?.colour) },
          ]}
        >
          <Text style={styles.statLabel}>
            {valueText(stat?.label, "")}
          </Text>
          <Text style={styles.statValue}>
            {valueText(stat?.value)}
          </Text>
        </View>
      ))}
    </View>
  );
};

const FindingText = ({ label, children }) => {
  if (!children) return null;

  return (
    <View wrap={false} style={styles.contentBlock}>
      <Text style={styles.tealLabel}>{label.toUpperCase()}</Text>
      <Text style={styles.body}>{children}</Text>
    </View>
  );
};

const Findings = ({ findings = [] }) => {
  if (!findings.length) return null;

  return (
    <View style={styles.section}>
      <SectionHeader icon="number-2" title="Four Key Findings" />

      {findings.map((finding, index) => (
        <View
          key={index}
          wrap={false}
          style={[styles.card, styles.topTeal]}
        >
          <View style={styles.findingHeader}>
            <Text style={styles.findingNumber}>
              {valueText(finding?.number, index + 1)}
            </Text>

            <Text style={styles.findingTitle}>
              {valueText(finding?.title, "")}
            </Text>
          </View>

          {finding?.subheading && (
            <Text style={styles.subheading}>
              {finding.subheading}
            </Text>
          )}

          <View style={styles.divider} />

          <FindingStats stats={finding?.stats} />

          <FindingText label="The Insight">
            {finding?.insight}
          </FindingText>

          <FindingText label="What This Means">
            {finding?.what_this_means}
          </FindingText>

          <FindingText label="What This Opens Up">
            {finding?.what_this_opens_up}
          </FindingText>

          {(finding?.recommendation_label ||
            finding?.recommendation) && (
              <View wrap={false} style={[styles.darkCallout, { marginTop: 14 }]}>
                <IconText
                  icon="target"
                  size={10}
                  textStyle={styles.tealLabel}
                  bottomSpacing={7}
                >
                  {finding?.recommendation_label || "Recommendation"}
                </IconText>

                {finding?.recommendation && (
                  <Text style={[styles.body, { color: COLORS.white }]}>
                    {finding.recommendation}
                  </Text>
                )}
              </View>
            )}
        </View>
      ))}
    </View>
  );
};

const MetricCard = ({
  title,
  icon,
  children,
  accent = COLORS.teal,
  style,
  wrap = false,
}) => (
  <View
    wrap={wrap}
    style={[
      styles.card,
      styles.topTeal,
      style,
      { borderTopColor: accent },
    ]}
  >
    {icon ? (
      <IconText
        icon={icon}
        textStyle={styles.cardTitle}
        bottomSpacing={9}
      >
        {title}
      </IconText>
    ) : (
      <Text style={styles.cardTitle}>{title}</Text>
    )}

    {children}
  </View>
);
const ExecutiveSnapshot = ({ snapshot }) => {
  if (!snapshot) return null;

  const hasTable =
    snapshot.table &&
    Array.isArray(snapshot.table.headers) &&
    snapshot.table.headers.length > 0 &&
    Array.isArray(snapshot.table.rows);

  return (
    <View style={styles.section}>
      <SectionHeader icon="number-3" title="Executive Snapshot" />

      <View style={styles.snapshotGrid}>
        {snapshot.portfolio_metrics?.length > 0 && (
          <MetricCard
            title="Portfolio Metrics"
            icon="target"
            style={styles.splitCard}
          >
            {snapshot.portfolio_metrics.map((metric, index) => (
              <View key={index} style={styles.keyValueRow}>
                <Text style={styles.keyValueLabel}>
                  {valueText(metric?.label, "")}
                </Text>
                <Text style={styles.keyValueValue}>
                  {valueText(metric?.value)}
                </Text>
              </View>
            ))}
          </MetricCard>
        )}

        {snapshot.paid_vs_free?.length > 0 && (
          <MetricCard
            title="Paid vs Free"
            icon="scales"
            style={styles.splitCard}
          >
            <View style={styles.splitRow}>
              {snapshot.paid_vs_free.map((item, index) => (
                <View
                  key={index}
                  style={[
                    styles.findingStat,
                    {
                      width: "48%",
                      backgroundColor: COLORS.lightBg,
                    },
                  ]}
                >
                  <Text style={styles.statLabel}>
                    {valueText(item?.label, "")}
                  </Text>
                  <Text style={styles.statValue}>
                    {valueText(item?.value)}
                  </Text>
                </View>
              ))}
            </View>
          </MetricCard>
        )}

        {snapshot.top_occupations?.length > 0 && (
          <MetricCard
            title="Top Occupations"
            icon="trophy"
            style={styles.splitCard}
          >
            {snapshot.top_occupations.map((item, index) => (
              <View
                key={index}
                style={[styles.listItem, { marginBottom: 9 }]}
              >
                <Text style={styles.rank}>
                  {valueText(item?.rank, index + 1)}
                </Text>

                <View
                  style={{
                    flexBasis: 0,
                    flexGrow: 1,
                    flexShrink: 1,
                    minWidth: 0,
                  }}
                >
                  <Text style={[styles.body, { fontWeight: "bold" }]}>
                    {valueText(item?.occupation, "")}
                  </Text>

                  {item?.note && (
                    <Text style={styles.muted}>{item.note}</Text>
                  )}
                </View>
              </View>
            ))}
          </MetricCard>
        )}

        {snapshot.areas_to_explore?.length > 0 && (
          <MetricCard
            title="Areas to Explore"
            icon="search"
            accent={COLORS.amber}
            style={styles.splitCard}
          >
            <BulletList
              items={snapshot.areas_to_explore}
              colour={COLORS.amber}
            />
          </MetricCard>
        )}
      </View>

      {snapshot.highlights && (
        <View style={styles.splitRow}>
          {snapshot.highlights.strongest_site && (
            <View
              wrap={false}
              style={[
                styles.card,
                styles.topTeal,
                styles.splitCard,
              ]}
            >
              <IconText
                icon="muscle"
                textStyle={styles.cardTitle}
                bottomSpacing={9}
              >
                Strongest Site
              </IconText>

              <Text style={[styles.body, { fontWeight: "bold" }]}>
                {valueText(
                  snapshot.highlights.strongest_site.site,
                  ""
                )}
              </Text>

              <Text style={styles.muted}>
                {valueText(
                  snapshot.highlights.strongest_site.note,
                  ""
                )}
              </Text>
            </View>
          )}

          {snapshot.highlights.weakest_site && (
            <View
              wrap={false}
              style={[
                styles.card,
                styles.topAmber,
                styles.splitCard,
              ]}
            >
              <IconText
                icon="search"
                textStyle={styles.cardTitle}
                bottomSpacing={9}
              >
                Site to Explore
              </IconText>

              <Text style={[styles.body, { fontWeight: "bold" }]}>
                {valueText(
                  snapshot.highlights.weakest_site.site,
                  ""
                )}
              </Text>

              <Text style={styles.muted}>
                {valueText(
                  snapshot.highlights.weakest_site.note,
                  ""
                )}
              </Text>
            </View>
          )}
        </View>
      )}

      {hasTable && (
        <MetricCard title="Comparison" icon="chart" wrap={false}>
          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]}>
              {snapshot.table.headers.map((header, index) => (
                <Text
                  key={index}
                  style={[styles.tableCell, styles.tableHeaderText]}
                >
                  {valueText(header, "")}
                </Text>
              ))}
            </View>

            {snapshot.table.rows.map((row, rowIndex) => (
              <View key={rowIndex} style={styles.tableRow}>
                {snapshot.table.headers.map((_, cellIndex) => (
                  <Text key={cellIndex} style={styles.tableCell}>
                    {valueText(row?.[cellIndex])}
                  </Text>
                ))}
              </View>
            ))}
          </View>
        </MetricCard>
      )}
    </View>
  );
};
const CostCenters = ({ data }) => {
  if (!data) return null;

  const headers = Array.isArray(data.table?.headers)
    ? data.table.headers
    : [];

  const rows = Array.isArray(data.table?.rows)
    ? data.table.rows
    : [];

  const hasTable = headers.length > 0;

  return (
    <View style={styles.section}>
      <SectionHeader icon="chart" title="Cost Center Performance" />

      {data.intro && (
        <View wrap={false} style={[styles.card, styles.leftTeal]}>
          <Text style={styles.body}>{data.intro}</Text>
        </View>
      )}

      {!!data.highlights?.length && (
        <View style={styles.snapshotGrid}>
          {data.highlights.map((item, index) => (
            <View
              key={index}
              wrap={false}
              style={[
                styles.card,
                index === 2 ? styles.topAmber : styles.topTeal,
                { width: "31.5%" },
              ]}
            >
              <Text style={styles.statLabel}>
                {valueText(item?.label, "")}
              </Text>

              <Text style={styles.statValue}>
                {valueText(item?.value)}
              </Text>
            </View>
          ))}
        </View>
      )}

      {hasTable && (
        <View style={styles.card}>
          <Text style={styles.cardTitle}>
            Site-by-Site Comparison
          </Text>

          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]}>
              {headers.map((header, index) => (
                <Text
                  key={index}
                  style={[styles.tableCell, styles.tableHeaderText]}
                >
                  {valueText(header, "")}
                </Text>
              ))}
            </View>

            {rows.map((row, rowIndex) => (
              <View key={rowIndex} style={styles.tableRow}>
                {headers.map((_, cellIndex) => (
                  <Text key={cellIndex} style={styles.tableCell}>
                    {valueText(row?.[cellIndex])}
                  </Text>
                ))}
              </View>
            ))}
          </View>

          {data.table?.omitted_note && (
            <Text style={[styles.muted, { marginTop: 8 }]}>
              {data.table.omitted_note}
            </Text>
          )}
        </View>
      )}

      <FindingText label="Site Performance Insight">
        {data.insight}
      </FindingText>

      <FindingText label="What This Means">
        {data.what_this_means}
      </FindingText>

      <FindingText label="What This Opens Up">
        {data.what_this_opens_up}
      </FindingText>

      {(data.recommendation_label || data.recommendation) && (
        <View style={[styles.darkCallout, { marginTop: 14 }]}>
          <IconText
            icon="target"
            size={10}
            textStyle={styles.tealLabel}
            bottomSpacing={7}
          >
            {data.recommendation_label || "Recommendation"}
          </IconText>

          {data.recommendation && (
            <Text style={[styles.body, { color: COLORS.white }]}>
              {data.recommendation}
            </Text>
          )}
        </View>
      )}
    </View>
  );
};
const WhatsWorking = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <View style={styles.section}>
      <SectionHeader
        icon="number-4"
        title="What's Working — Build on This"
      />

      {items.map((item, index) => (
        <View
          key={index}
          wrap={false}
          style={[styles.card, styles.leftTeal]}
        >
          <IconText
            icon="check"
            size={15}
            textStyle={styles.cardTitle}
            bottomSpacing={9}
          >
            {valueText(item?.label, "")}
          </IconText>

          <Text style={styles.body}>
            {valueText(item?.detail, "")}
          </Text>
        </View>
      ))}
    </View>
  );
};

const WhyNow = ({ data }) => {
  if (!data) return null;

  return (
    <View style={styles.section}>
      <SectionHeader
        icon="number-5"
        title="Why Now — Fine-Tuning, Not Overhaul"
      />

      <View wrap={false} style={[styles.card, styles.topTeal]}>
        {data.opening_statement && (
          <Text style={styles.body}>
            {data.opening_statement}
          </Text>
        )}

        {data.recommendations_recap?.length > 0 && (
          <View style={{ marginTop: 16 }}>
            <IconText
              icon="target"
              textStyle={styles.cardTitle}
              bottomSpacing={9}
            >
              Recommendations Recap
            </IconText>

            {data.recommendations_recap.map((item, index) => (
              <View key={index} style={styles.listItem}>
                <Text style={[styles.rank, { color: COLORS.teal }]}>
                  •
                </Text>

                <Text
                  style={[
                    styles.body,
                    {
                      flexBasis: 0,
                      flexGrow: 1,
                      flexShrink: 1,
                      minWidth: 0,
                      fontWeight: "bold",
                    },
                  ]}
                >
                  {valueText(item, "")}
                </Text>
              </View>
            ))}
          </View>
        )}

        {data.expected_outcome && (
          <View style={[styles.expectedOutcome, styles.iconTextRow]}>
            <PdfIcon
              icon="sparkles"
              size={13}
              style={{ marginRight: 6 }}
            />

            <Text style={styles.expectedOutcomeText}>
              {data.expected_outcome}
            </Text>
          </View>
        )}
      </View>
    </View>
  );
};

const ReportPage = ({ children }) => (
  <Page size="A4" style={styles.page}>
    <View fixed style={styles.pageHeader}>
      <Image src={hiLogo} style={styles.headerLogo} />
    </View>

    {children}

    <View fixed style={styles.pageFooter}>
      <Text
        style={styles.footerText}
        render={({ pageNumber, totalPages }) =>
          `${pageNumber} / ${totalPages}`
        }
      />
    </View>
  </Page>
);

const AnalysisMasterSummaryPdf = ({ report }) => {
  if (!report) return null;

  return (
    <Document
      title="Master Buyer Executive Summary"
      author="Hire Intelligence"
    >
      {/* Page 1: Hero and One-Minute Read */}
      <ReportPage>
        <Hero report={report} />
        <OneMinuteRead data={report?.one_minute_read} />
      </ReportPage>

      {/* Page 2: Four Key Findings */}
      {report?.findings?.length > 0 && (
        <ReportPage>
          <Findings findings={report.findings} />
        </ReportPage>
      )}

      {/* Page 3: Executive Snapshot */}
      {hasSnapshotContent(report?.executive_snapshot) && (
        <ReportPage>
          <ExecutiveSnapshot snapshot={report.executive_snapshot} />
        </ReportPage>
      )}

      {/* Page 4: What's Working */}
      {report?.whats_working?.length > 0 && (
        <ReportPage>
          <WhatsWorking items={report.whats_working} />
        </ReportPage>
      )}

      {/* Page 5: Cost Center Performance */}
      {report?.cost_centers && (
        <ReportPage>
          <CostCenters data={report.cost_centers} />
        </ReportPage>
      )}

      {/* Page 6: Why Now */}
      {hasWhyNowContent(report?.why_now) && (
        <ReportPage>
          <WhyNow data={report.why_now} />
        </ReportPage>
      )}
    </Document>
  );
};

export default AnalysisMasterSummaryPdf;